<!--
 * @Description: In User Settings Edit
 * @Author: your name
 * @Date: 2019-06-27 17:55:33
 * @LastEditTime: 2019-08-17 14:36:54
 * @LastEditors: Please set LastEditors
 -->
<template>
  <el-dialog
    title="选择经纬度"
    :visible="true"
    width="70%"
    :append-to-body="true"
    :before-close="handleClose"
  >
    <el-form ref="form" :model="form" label-width="100px" :inline="true">
      <el-form-item label="门店地址:">
        <!-- <el-select  v-model="form.country" placeholder="国" clearable style="margin-right:10px" @change='getprovinces()'>
                            <el-option v-for=" i in countrys" :key="i.id" :label="i.region_name"
                                       :value="i.region_id"></el-option>
                        </el-select> -->
        <el-select
          v-model="form.province"
          placeholder="省"
          clearable
          style="margin-right: 10px"
          @change="getcity"
        >
          <el-option
            v-for="i in provinces"
            :key="i.id"
            :label="i.region_name"
            :value="i.region_id"
          ></el-option>
        </el-select>
        <el-select
          v-model="form.city"
          placeholder="市"
          clearable
          style="margin-right: 10px"
          @change="getArea"
        >
          <el-option
            v-for="i in citys"
            :key="i.id"
            :label="i.region_name"
            :value="i.region_id"
          ></el-option>
        </el-select>
        <el-select
          v-model="form.area"
          placeholder="区"
          clearable
          style="margin-right: 10px"
          @change="update"
        >
          <el-option
            v-for="i in areas"
            :key="i.id"
            :label="i.region_name"
            :value="i.region_id"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item class="adress">
        <el-input
          v-model="form.address"
          placeholder="请输入详细地址,请勿重复填写省市区"
          id="addressInput"
          clearable
        ></el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="theLocation()">搜索标注</el-button>
      </el-form-item>
    </el-form>

    <div id="areaBox">
      <div class="side fl" id="r-result"></div>
      <div id="chooseLatLng"></div>
    </div>

    <div class="bottom tc">
      <el-button type="primary" @click="confirm">确认</el-button>
      <el-button @click="handleClose">取消</el-button>
    </div>
  </el-dialog>
  <!-- //  -->
</template>

<script>
import { MP } from "./Bmap.js";
import axios from "axios";
import $ from "jquery";
export default {
  name: "map",
  data() {
    return {
      ak: "PcrNnwCrydW45PuxBfK50aM23OGiC5CT", //密钥,
      mapData: {},
      infoWindow: {
        show: false,
      },
      map: {
        width: "auto",
        height: "100%",
      },
      form: {
        province: "",
        city: "",
        address: "",
        area: "",
      },
      addressRS: [], //搜索的所有返回值数组
      map: {},
      BMap: {},
      endData: {},
      countrys: [],
      provinces: [],
      citys: [],
      areas: [],
      p: "",
      c: "",
      a: "",
    };
  },
  created() {
    this.init();
    this.getprovinces();
  },
  mounted() {
    this.init();
  },
  methods: {
    init() {
      this.$nextTick(function () {
        var _this = this;

        //在此调用api
        _this.BMap = BMap;
        _this.map = new BMap.Map("chooseLatLng");
        _this.map.centerAndZoom(new BMap.Point(116.3964, 39.9093), 10);
        _this.map.enableScrollWheelZoom();
        var geoc = new BMap.Geocoder();
        _this.map.addEventListener("click", function (e) {
          _this.map.clearOverlays();
          console.log(e.point.lat);
          _this.lat = e.point.lat;
          _this.lng = e.point.lng;
          _this.endData.point = e.point;
          _this.map.addOverlay(
            new BMap.Marker(new BMap.Point(_this.lng, _this.lat))
          );
          geoc.getLocation(new BMap.Point(_this.lng, _this.lat), function (rs) {
            var addComp = rs.address;
            _this.theLocation();
          });
        });
      });
    },
    // 获取四级联动
    getcountry() {
      this.$get("logistics_2", "/vstore/dealer_pc/area", {
        type: 1,
        parent_id: "",
      })
        .then((res) => {
          this.countrys = res.data;
          this.citys = [];
          this.areas = [];
          this.provinces = [];
        })
        .catch((error) => {});
    },
    getprovinces(val, text) {
      this.citys = [];
      this.provinces = [];
      this.areas = [];
      this.form.province = "";
      this.form.city = "";
      this.form.area = "";
      this.$get("logistics_2", "/vstore/dealer_pc/area", {
        type: 2,
        parent_id: 1,
      })
        .then((res) => {
          this.provinces = res.data;
        })
        .catch((error) => {});
    },
    getcity(val) {
      this.p = this.provinces.find((item) => {
        //这里的chargingWorkNameList就是上面遍历的数据源
        return item.region_id === val;
      });
      (this.c = ""), (this.a = "");
      this.$forceUpdate();
      this.citys = [];
      this.areas = [];
      this.form.city = "";
      this.form.area = "";
      this.$get("logistics_2", "/vstore/dealer_pc/area", {
        type: 2,
        parent_id: this.form.province,
      })
        .then((res) => {
          this.citys = res.data;
        })
        .catch((error) => {});
    },
    getArea(val) {
      this.c = this.citys.find((item) => {
        //这里的chargingWorkNameList就是上面遍历的数据源
        return item.region_id === val;
      });

      this.a = "";

      this.$forceUpdate();
      this.areas = [];
      this.form.area = "";
      this.$get("logistics_2", "/vstore/dealer_pc/area", {
        type: 2,
        parent_id: this.form.city,
      })
        .then((res) => {
          this.areas = res.data;
        })
        .catch((error) => {});
    },
    update(val) {
      this.$forceUpdate();

      this.a = this.areas.find((item) => {
        //这里的chargingWorkNameList就是上面遍历的数据源
        return item.region_id === val;
      });
    },
    handleClose() {
      this.$emit("handleClose");
    },
    theLocation() {
      var _this = this;
      var address =
        this.p.region_name +
        this.c.region_name +
        this.a.region_name +
        this.form.address;
      var local = new BMap.LocalSearch(_this.map, {
        renderOptions: { map: _this.map, panel: "r-result" },
      });
      local.search(address);

      local.setSearchCompleteCallback(function (rs) {
        _this.addressRS = rs.Hr;
      });
      setTimeout(function () {
        var mRli = $("#r-result ol li");
        var _address = "";
        if (mRli.length == 1) {
          return false;
        }
        var myGeo = new BMap.Geocoder();
        mRli.unbind("click").click(function () {
          _this.endData = _this.addressRS[$(this).index()];
        });
      }, 1000);
    },
    shiwInfo(e) {
      if (e.point) {
        lng = e.point.lng;
        lat = e.point.lat;
        this.map.clearOverlays();
        createMaker(e);
      } else {
        lng = e.lng;
        lat = e.lat;
      }
    },
    confirm() {
      var point = {
        lng: this.lng,
        lat: this.lat,
      };
      this.$emit("confirm", this.endData);
    },
  },
  components: {},
};
</script>

<style lang="scss" scoped>
.adress {
  /deep/ .el-form-item__content:last-child {
    width: 250px;
    input {
      padding-right: 0;
    }
  }
}

#areaBox {
  margin-bottom: 10px;
  width: 100%;
  height: 400px;
  .side {
    display: inline-block;
    width: 30%;
    height: 400px;
    background-color: #f8f8f8;
    border: 1px solid #ddd;
    box-sizing: border-box;
    overflow-y: auto;
  }
  #chooseLatLng {
    overflow: hidden;
    position: relative;
    z-index: 0;
    background-color: rgb(243, 241, 236);
    color: rgb(0, 0, 0);
    text-align: left;
    display: inline-block;
    width: 68%;
    height: 400px;
    float: left !important;
  }
}
</style>
